export enum FieldIds
{
  USR        = 'username',
  PWD        = 'password',
  VERIF_CODE = 'verificationCode'
}
